/**
 * Opens the restricted popup when the B2B gate has bounced someone here.
 *
 * Uses <dialog>.showModal(), which brings focus trapping, Escape to close and
 * an inert background without writing any of it. Closing also strips the
 * ?b2b=restricted parameter, so a refresh or a shared link does not reopen it.
 */

const PARAM = 'b2b';
const VALUE = 'restricted';

function clearParam() {
  const url = new URL(window.location.href);
  if (!url.searchParams.has(PARAM)) return;
  url.searchParams.delete(PARAM);
  // replaceState, not pushState: closing the popup should not add history.
  window.history.replaceState({}, '', url.pathname + url.search + url.hash);
}

function init() {
  const params = new URLSearchParams(window.location.search);
  if (params.get(PARAM) !== VALUE) return;

  const modal = document.querySelector('[data-b2b-modal]');
  if (!modal) return;

  const close = () => {
    if (modal.open) modal.close();
  };

  if (typeof modal.showModal === 'function') {
    modal.showModal();
  } else {
    // Very old browsers: no <dialog>. Show it rather than silently doing
    // nothing, so the message still lands.
    modal.setAttribute('open', '');
  }

  modal.querySelectorAll('[data-b2b-close]').forEach((button) => {
    button.addEventListener('click', close);
  });

  // Clicking the backdrop. The dialog element itself fills the whole viewport
  // as far as the event target is concerned, so anything landing on the dialog
  // rather than its children is a backdrop click.
  modal.addEventListener('click', (event) => {
    if (event.target !== modal) return;
    const box = modal.getBoundingClientRect();
    const inside =
      event.clientX >= box.left &&
      event.clientX <= box.right &&
      event.clientY >= box.top &&
      event.clientY <= box.bottom;
    if (!inside) close();
  });

  modal.addEventListener('close', clearParam);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
